<template>
  <d2-container>
    <template slot="header">
      <el-select v-model="query.channelId" clearable filterable placeholder="渠道" size="small" style="width: 180px; margin-right: 8px;">
        <el-option label="全部" value=""></el-option>
        <el-option
          v-for="item in channelOptions"
          :key="item.channelId"
          :label="`${item.channelName || item.channelId} (${item.channelId})`"
          :value="item.channelId"
        ></el-option>
      </el-select>
      <el-select v-model="query.endpoint" clearable placeholder="接口" size="small" style="width: 180px; margin-right: 8px;">
        <el-option label="/v1/chat/completions" value="/v1/chat/completions"></el-option>
        <el-option label="/v1/responses" value="/v1/responses"></el-option>
      </el-select>
      <el-input v-model.trim="query.model" clearable size="small" placeholder="模型" style="width: 160px; margin-right: 8px;" @keyup.enter.native="handleSearch"></el-input>
      <el-select v-model="query.status" clearable placeholder="状态" size="small" style="width: 140px; margin-right: 8px;">
        <el-option label="已结算" value="SUCCESS"></el-option>
        <el-option label="等待用量" value="PENDING_USAGE"></el-option>
        <el-option label="失败" value="FAILED"></el-option>
      </el-select>
      <el-select v-model="query.stream" clearable placeholder="流式" size="small" style="width: 110px; margin-right: 8px;">
        <el-option label="是" :value="true"></el-option>
        <el-option label="否" :value="false"></el-option>
      </el-select>
      <el-input v-model.trim="query.ownerId" clearable size="small" placeholder="空间/账户ID" style="width: 140px; margin-right: 8px;" @keyup.enter.native="handleSearch"></el-input>
      <el-input v-model.trim="query.keyword" clearable size="small" placeholder="请求号/上游ID/错误" style="width: 220px; margin-right: 8px;" @keyup.enter.native="handleSearch"></el-input>
      <el-date-picker
        v-model="dateRange"
        type="datetimerange"
        size="small"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        style="width: 340px; margin-right: 8px;"
      ></el-date-picker>
      <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button size="small" icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="requestNo" label="请求号" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="endpoint" label="接口" min-width="170" show-overflow-tooltip></el-table-column>
      <el-table-column label="渠道" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ formatChannel(scope.row.channelId) }}</template>
      </el-table-column>
      <el-table-column prop="model" label="模型" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="流式" width="70" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.stream ? 'primary' : 'info'">{{ scope.row.stream ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="105" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="getStatusTag(scope.row.status)">{{ formatStatus(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="httpStatus" label="HTTP" width="75" align="center"></el-table-column>
      <el-table-column label="Token" min-width="210" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatTokens(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="扣费" width="115" align="center">
        <template slot-scope="scope">
          <span class="point-text">{{ formatPoint(scope.row.actualPoints) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预冻结" width="115" align="center">
        <template slot-scope="scope">{{ formatPoint(scope.row.reservePoints) }}</template>
      </el-table-column>
      <el-table-column label="空间" min-width="130" show-overflow-tooltip>
        <template slot-scope="scope">{{ formatOwner(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="upstreamResponseId" label="上游响应ID" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="errorMessage" label="错误信息" min-width="220" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170" align="center"></el-table-column>
      <el-table-column prop="settledAt" label="结算时间" width="170" align="center"></el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </d2-container>
</template>

<script>
import {
  getChannelConfigList,
  getOpenAiProxyRequestList
} from '@/api/merchant/service/channel'

export default {
  name: 'openAiProxyRequestManager',
  data () {
    return {
      loading: false,
      records: [],
      total: 0,
      channelOptions: [],
      dateRange: [],
      query: this.defaultQuery()
    }
  },
  created () {
    this.loadChannels()
    this.loadList()
  },
  methods: {
    defaultQuery () {
      return {
        currentPage: 1,
        pageSize: 20,
        channelId: '',
        endpoint: '',
        model: '',
        ownerId: '',
        status: '',
        stream: '',
        keyword: '',
        startTime: '',
        endTime: ''
      }
    },
    normalizeList (res) {
      if (Array.isArray(res)) return res
      if (res && Array.isArray(res.records)) return res.records
      if (res && Array.isArray(res.list)) return res.list
      return []
    },
    normalizePage (res) {
      return {
        records: res && Array.isArray(res.records) ? res.records : [],
        total: Number(res && res.total ? res.total : 0)
      }
    },
    loadChannels () {
      return getChannelConfigList({ channelType: 'llm' }).then(res => {
        this.channelOptions = this.normalizeList(res)
      })
    },
    buildQuery () {
      const data = Object.assign({}, this.query)
      if (Array.isArray(this.dateRange) && this.dateRange.length === 2) {
        data.startTime = this.dateRange[0]
        data.endTime = this.dateRange[1]
      } else {
        data.startTime = ''
        data.endTime = ''
      }
      if (data.stream === '') {
        delete data.stream
      }
      if (!data.ownerId) {
        delete data.ownerId
      }
      return data
    },
    loadList () {
      this.loading = true
      return getOpenAiProxyRequestList(this.buildQuery()).then(res => {
        const page = this.normalizePage(res)
        this.records = page.records
        this.total = page.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch () {
      this.query.currentPage = 1
      this.loadList()
    },
    resetSearch () {
      this.dateRange = []
      this.query = this.defaultQuery()
      this.loadList()
    },
    handleSizeChange (size) {
      this.query.pageSize = size
      this.query.currentPage = 1
      this.loadList()
    },
    handleCurrentChange (page) {
      this.query.currentPage = page
      this.loadList()
    },
    formatChannel (channelId) {
      const channel = this.channelOptions.find(item => item.channelId === channelId)
      return channel ? `${channel.channelName || channelId} (${channelId})` : (channelId || '-')
    },
    formatOwner (row) {
      const type = row.ownerType || '-'
      const id = row.ownerId || '-'
      return `${type} / ${id}`
    },
    formatTokens (row) {
      const input = Number(row.inputTokens || 0)
      const cached = Number(row.cachedInputTokens || 0)
      const output = Number(row.outputTokens || 0)
      const reasoning = Number(row.reasoningTokens || 0)
      const total = Number(row.totalTokens || 0)
      return `I:${input} C:${cached} O:${output} R:${reasoning} T:${total}`
    },
    formatPoint (value) {
      const n = Number(value || 0)
      if (Number.isNaN(n)) {
        return value || '0'
      }
      return n.toFixed(4).replace(/0+$/, '').replace(/\.$/, '')
    },
    formatStatus (status) {
      if (status === 'SUCCESS') return '已结算'
      if (status === 'PENDING_USAGE') return '等待用量'
      if (status === 'FAILED') return '失败'
      if (status === 'RESERVED') return '已冻结'
      return status || '-'
    },
    getStatusTag (status) {
      if (status === 'SUCCESS') return 'success'
      if (status === 'PENDING_USAGE' || status === 'RESERVED') return 'warning'
      if (status === 'FAILED') return 'danger'
      return 'info'
    }
  }
}
</script>

<style scoped>
.pagination-wrap {
  padding-top: 14px;
  text-align: right;
}

.point-text {
  color: #f56c6c;
  font-weight: 700;
}
</style>
